var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPinX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5599 53.0099C31.6044 53.5787 30.4866 53.8128 29.3832 53.6751C28.2798 53.5375 27.2538 53.036 26.4673 52.2499L15.8573 41.6424C13.3114 39.0946 11.5007 35.9067 10.6165 32.4152C9.73224 28.9237 9.80727 25.2581 10.8337 21.8057C11.8601 18.3533 13.7997 15.2422 16.4478 12.8008C19.0958 10.3594 22.3541 8.67842 25.8783 7.93537C29.4026 7.19231 33.0621 7.41476 36.4704 8.57921C39.8788 9.74367 42.9094 11.8069 45.2422 14.5511C47.5751 17.2952 49.1236 20.6184 49.7243 24.1697C50.325 27.721 49.9555 31.3686 48.6549 34.7274M55.0001 54.9999L42.5001 42.4999M42.5001 54.9999L55.0001 42.4999M22.5001 27.4999C22.5001 29.4891 23.2903 31.3967 24.6968 32.8032C26.1033 34.2098 28.011 34.9999 30.0001 34.9999C31.9892 34.9999 33.8969 34.2098 35.3034 32.8032C36.7099 31.3967 37.5001 29.4891 37.5001 27.4999C37.5001 25.5108 36.7099 23.6032 35.3034 22.1966C33.8969 20.7901 31.9892 19.9999 30.0001 19.9999C28.011 19.9999 26.1033 20.7901 24.6968 22.1966C23.2903 23.6032 22.5001 25.5108 22.5001 27.4999Z",
    stroke: "#F74439",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinX);
export default __webpack_public_path__ + "static/media/map-pin-x.0aa462c498ba120861bffd1a1e80dabb.svg";
export { ForwardRef as ReactComponent };